import RadioBoomChart from './RadioBoomChartNoBox';
function App() {
  return <RadioBoomChart />;
}

export default App;


